(() => {
    /**
     * @type {StoreAssociation}
     */
    const allStoresMarker = {
        Id: 0,
        Name: null,
        Address: null,
        TelephoneNumber: null
    };

    class StoreListOptions {
        label = "Stores";

        get target() {
            return this._target;
        }

        set target(value) {
            this._target = value;
        }

        _target = [];
        itemText = o => o.Name;

        constructor(ctrl) {
            this._ctrl = ctrl;
        }

        get source() {
            return this._ctrl.filteredStores;
        }
    }

    class ManageCampaignTemplateStoreAssociationsController {

        APIService;
        $element;
        $state;
        notify;
        CampaignDesignerService;
        StoresService;
        ErrorService;
        $scope;
        $rootScope;
        provinces;
        campaignTemplate;
        filteredStores;
        selectedProvince;
        provinceIdToStoreIdsMap;
        originalStoreAssociations;

        get isAvailableToAllStores() {
            return !!this._isAvailableToAllStores;
        }

        set isAvailableToAllStores(value) {
            this._isAvailableToAllStores = value;
            this.setAvailableToAllStores(value);
        }

        _isAvailableToAllStores;

        constructor(
            $element,
            $rootScope,
            $scope,
            StoresService,
            ErrorService,
            CampaignDesignerService,
            notify,
            $state,
            APIService
        ) {
            this.provinces = [];
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.StoresService = StoresService;
            this.ErrorService = ErrorService;
            this.CampaignDesignerService = CampaignDesignerService;
            this.notify = notify;
            this.$state = $state;
            this.$el = $element;
            this.APIService = APIService;
            this.userContext = {};
            this.storeListOptions = new StoreListOptions(this);
        }

        get navigationBlocked() {
            return !this.isAvailableToAllStores &&
                this.storeListOptions.target.length === 0;
        }

        get navigationBlockedMessage() {
            return this.navigationBlocked
                ? "You must select at least one store to continue"
                : "";
        }

        $onInit() {
            this.isAvailableToAllStores = this.campaignTemplate.IsAvailableToAllStores;
            if (!Array.isArray(this.campaignTemplate.StoreAssociations)) {
                this.campaignTemplate.StoreAssociations = [];
            }
            this.originalStoreAssociations = [
                ...this.campaignTemplate.StoreAssociations
            ];
            this.filteredStores = [];
            this.removeDefaultBrandLevelStore();
            this.loadStoreSelectionFilters();
            this.loadStores();

            this.navigationWatch = this.$scope.$watch(
                () => this.navigationBlocked,
                () => {
                    this.$rootScope.$emit(
                        "disable-wizard-navigation", {
                            disabled: this.navigationBlocked,
                            message: this.navigationBlockedMessage
                        }
                    );
                }
            );
        };

        $onDestroy() {
            this.navigationWatch();
        }

        selectOriginalStoreAssociations() {
            const selectedIds = new Set(this.originalStoreAssociations.map(o => o.Id));
            for (const item of this.storeListOptions.source) {
                if (selectedIds.has(item.Id)) {
                    this.storeListOptions.target.push(item);
                }
            }
        }

        loadStoreSelectionFilters() {
            this.$scope.$root.isLoading = true;
            this.APIService.Provinces.listAllProvinces()
                .then(result => {
                    const template = result.data[0];
                    let all = {
                        Id: 0,
                        Name: "All"
                    };
                    if (template) {
                        all = {
                            ...template,
                            ...all
                        }
                    }
                    this.provinces = [ all ].concat(result.data || []);
                    this.selectedProvince = all.Id;
                });
        }

        filterStores() {
            if (!this.provinceIdToStoreIdsMap) {
                return;
            }
            const storesPerProvinceMap = new Set(this.provinceIdToStoreIdsMap[this.selectedProvince] || []);
            this.filteredStores = this.allStores.filter(
                o => this.allProvincesSelected() || storesPerProvinceMap.has(o.Id)
            );
        }

        allProvincesSelected() {
            return this.selectedProvince === 0;
        }

        loadStores() {
            this.$scope.$root.isLoading = true;
            this.StoresService.getStoresForBrand(this.userContext.BrandId, true)
                .then(result => {
                        const
                            rawStores = result.data.Stores,
                            allStores = _.map(rawStores, (store) => {
                                return {
                                    Id: store.Id,
                                    Name: store.Name
                                }
                            });
                        this.provinceIdToStoreIdsMap = rawStores.reduce(
                            (acc, cur) => {
                                if (!acc[cur.ProvinceId]) {
                                    acc[`${cur.ProvinceId}`] = [];
                                }
                                acc[`${cur.ProvinceId}`].push(cur.Id);
                                return acc;
                            }, {}
                        );
                        this.allStores = _.sortBy(allStores, "Name");
                        this.filteredStores = this.allStores;
                        this.selectOriginalStoreAssociations();
                    }
                )
                .catch(result => {
                        this.ErrorService.showError('An error occurred when loading the campaign template', result);
                    }
                )
                .finally(() => {
                        this.$scope.$root.isLoading = false;
                    }
                );
        };

        removeDefaultBrandLevelStore() {
            this.campaignTemplate.StoreAssociations = _.reject(this.campaignTemplate.StoreAssociations, function (association) {
                return association.Id === 0;
            });
        };

        setAvailableToAllStores(isAvailableToAllStores) {
            this.campaignTemplate.IsAvailableToAllStores = isAvailableToAllStores;
            if (isAvailableToAllStores) {
                this.campaignTemplate.StoreAssociations.splice(
                    0,
                    this.campaignTemplate.StoreAssociations.length
                );
            }
        }

        sortStores() {
            this.campaignTemplate.StoreAssociations = _.sortBy(this.campaignTemplate.StoreAssociations, "Name");
            this.filteredStores = _.sortBy(this.filteredStores, "Name");
        };

        goBack() {
            return this.saveThenGoTo(
                window.Dashboard.helpers.stateHelper.getParentState(
                    this.$state.current.name
                )
            );
        };

        goNext() {
            const nextState = window.Dashboard.helpers.stateHelper.getParentState(
                this.$state.current.name
            ) + ".vouchers";
            return this.saveThenGoTo(nextState);
        }

        saveThenGoTo(state) {
            this.$scope.$root.isLoading = true;
            this.campaignTemplate.StoreAssociations.splice(0, this.campaignTemplate.StoreAssociations.length);
            if (this._isAvailableToAllStores) {
                this.campaignTemplate.StoreAssociations = [
                    { ...allStoresMarker }
                ]
            } else {
                for (const store of this.storeListOptions.target) {
                    this.campaignTemplate.StoreAssociations.push(store);
                }
            }

            this.CampaignDesignerService.updateCampaignTemplateStores(
                this.campaignTemplate.TemplateGuid,
                this.campaignTemplate.StoreAssociations,
                this.$state.params.brandId
            ).then(() => {
                    this.notify.success('The campaign template associations was successfully saved');
                    this.$state.go(
                        state, {
                            brandId: this.userContext.BrandId,
                            CampaignTemplateGuid: this.campaignTemplate.TemplateGuid
                        });
                }
            ).catch(result => {
                    this.ErrorService.showError('An error occurred when saving the campaign template associations', result);
                }
            ).finally(() => {
                    this.$scope.$root.isLoading = false;
                }
            );
        };
    }

    angular
        .module("dashboard")
        .component("manageCampaignTemplateStores", {
            templateUrl: "components/campaigndesigner/managecampaigntemplates/storeassociations/campaigntemplatestoreassociations.c21d8d65.html",
            bindings: {
                campaignTemplate: "=",
                userContext: "<"
            },
            controller: [
                "$element",
                "$rootScope",
                "$scope",
                "StoresService",
                "ErrorService",
                "CampaignDesignerService",
                "notify",
                "$state",
                "APIService",
                ManageCampaignTemplateStoreAssociationsController
            ]
        });
})();
